import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateVipUserPlan extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUser/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllVipPlans extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUser/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAVipPlan extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUser/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleVipPlan extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUser/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateASingleVipPlan extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUser/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteUserVipPlan extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUser/DeleteUserVipPlan");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class AddVipPlanToUser extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUser/ActiveVipPlanForUser");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateVipUserPlan,
  GetAllVipPlans,
  DeleteAVipPlan,
  GetASingleVipPlan,
  UpdateASingleVipPlan,
  DeleteUserVipPlan,
  AddVipPlanToUser,
};
